<script setup lang="ts">
import { useNavigation } from './useNavigation'
import HelpButton from '@/ui-kit/layout/HelpButton.vue'

const { getLink: $getLink, gotoOnClick: $gotoOnClick } = useNavigation()
</script>

<template>
  <HelpButton class="parent-help-button">
    <template #icon>
      <v-icon>mdi-account-multiple</v-icon>
    </template>

    <template #prepend>
      <v-link class="help-button__link text-body-bold" :href="$getLink({ tab: 'parent-info' })" @click="$gotoOnClick">
        <v-icon class="mr-1">mdi-book-open-blank-variant</v-icon>
        <span class="flex-spacer">Информация по пособию</span>
      </v-link>

      <v-link class="help-button__link text-body-bold" :href="$getLink({ tab: 'mode-info' })" @click="$gotoOnClick">
        <v-icon class="mr-1">mdi-cog</v-icon>
        <span class="flex-spacer">Режим кабинета ученика</span>
      </v-link>

      <v-link class="help-button__link text-body-bold" :href="$getLink({ hash: 'onboarding' })" @click="$gotoOnClick">
        <v-icon class="mr-1">mdi-message-processing</v-icon>
        <span class="flex-spacer">Показать подсказки</span>
      </v-link>
    </template>
  </HelpButton>
</template>

<style lang="scss">
@use '~/styles/pages/student2/screen' as s2;

.parent-help-button .help-button {
  right: 88px + 24px; // UnitSelect width

  @include s2.mobile {
    right: 72px + 24px;
  }
}
</style>
